import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <Section tone="tint" eyebrow="Témoignages" title="Ce qu’en disent ceux qui utilisent déjà le matériel" width="narrow" data-id="element-181" data-mp="3fze2zvj28zum">
      <ul className="mx-auto max-w-4xl divide-y divide-slate-200" data-id="element-182" data-mp="3b1cir79weuhk">
        {testimonials.map(item => <li key={`${item.author}-${item.city}`} className="grid gap-4 py-7 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,15rem)_1fr] md:gap-10" data-id="element-183" data-mp="3700q0svq9t55">
            <div className="flex items-start gap-3" data-id="element-184" data-mp="2x09wouiwlk6n">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-600 text-xs font-bold text-white" data-id="element-185" data-mp="2x2w2aom8hpm8">
                {item.initials}
              </span>
              <span data-id="element-186" data-mp="v8nbxaplulim">
                <span className="flex gap-0.5" role="img" aria-label="5 étoiles sur 5" data-id="element-187" data-mp="v72i5nb476lt">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-188" data-mp="h55ai23t7vx3" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-extrabold tracking-tight text-slate-900" data-id="element-189" data-mp="780k1q2xleah">{item.author}</span>
                <span className="block text-sm text-slate-600" data-id="element-190" data-mp="c6bspxhhpir4">{item.role}</span>
                <span className="inline-flex items-center gap-1 text-sm text-slate-500" data-id="element-191" data-mp="zwfvy3qrnghl">
                  <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-192" data-mp="zyseoj4cluvp" />
                  {item.city}
                </span>
              </span>
            </div>
            <div data-id="element-193" data-mp="q63fonpzi9h9">
              <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-194" data-mp="q4jymuwi7uef">{item.note}</p>
              <blockquote className="text-lg italic leading-relaxed text-slate-900 md:text-xl" data-id="element-195" data-mp="v3d0fq2fhwyr">
                « {item.quote} »
              </blockquote>
            </div>
          </li>)}
      </ul>
    </Section>;
}